import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import Header from '../../components/Header/Header';
import Breadcrumbs from '../../components/Breadcrumbs';
import Navbar from '../../components/Navbar/Navbar';
import icon from '../../assets/sidebar/uploadWhite.svg';
import isUserHaveRole from '../../utils/isUserHaveRole';
import { ROLE_ADMIN } from '../../constants/roles';

export const VIN_BLACKLIST_TABS = [
  { text: 'Список VIN', navigate: '/vin-blacklist' },
  { text: 'Машины в базе', navigate: '/vin-blacklist/cars' },
];

// Чёрный список VIN: две вкладки, как у «Сделок» и «Клиентов». Только администратор: бэк тоже проверяет
// роль, здесь — чтобы остальным не показывать страницу с ошибками.
const VinBlacklistNavigation = () => {
  const { pathname } = useLocation();

  if (!isUserHaveRole(ROLE_ADMIN)) {
    return <Navigate to="/" replace />;
  }

  const current = VIN_BLACKLIST_TABS.find((tab) => tab.navigate === pathname) || VIN_BLACKLIST_TABS[0];

  return (
    <>
      <Header title="Чёрный список VIN" icon={icon} />
      <Breadcrumbs navigate="/vin-blacklist" link="Чёрный список VIN" currentPage={current.text} />
      <Navbar items={VIN_BLACKLIST_TABS} />
      <Outlet />
    </>
  );
};

export default VinBlacklistNavigation;
